import React from 'react';
import { useHistory } from 'react-router';

// Constants
import PageUrls from 'Shared/constants/PageUrls.constants';

// Components
import IntegrationsWrapper from 'Dashboard/components/IntegrationsWrapper/IntegrationsWrapper';
import { WpButton } from 'Wpds/components/button';

// Styles
import './SurfaceAIIntegrations.scss';

type Props = {
  button?: React.ReactNode;
};

const SurfaceAIIntegrations = ({ button }: Props) => {
  const history = useHistory();

  const handleSeeAllClick = () => {
    history.push(PageUrls.SETTINGS_INTEGRATIONS_PAGE);
  };

  const baseClassName = 'SurfaceAIIntegrations';
  return (
    <div className={`${baseClassName}`}>
      {button && <div className={`${baseClassName}__button`}>{button}</div>}
      <IntegrationsWrapper filters={{ surfaceAI: true }} redirectUrl={PageUrls.TEAM_PAGE_SURFACE_AI} />
      <div className={`${baseClassName}__see-more-button`}>
        <WpButton size="lg" variant="secondary" onClick={handleSeeAllClick}>
          See All Integrations
        </WpButton>
      </div>
    </div>
  );
};

export default SurfaceAIIntegrations;
